module.exports = __webpack_public_path__ + "img/spinner.af912864.svg";